import { connect } from 'react-redux';
import { selectors as streamSelectors, withOffset } from '../Stream';
import { getCurrentUser } from '../publicSession/selectors';
import { fetchNext } from './redux/actionCreators';
const getStreamId = (typeId, deviationId)=>`favouritedBy-${typeId}-${deviationId}`;
const mapStateToProps = (state, props)=>{
    const streamId = getStreamId(props.typeId, props.deviationId);
    return {
        streamId,
        users: streamSelectors.getItems(state, streamId),
        isLoading: streamSelectors.isFetching(state, streamId),
        isInitialized: streamSelectors.isInitialized(state, streamId),
        currentUser: getCurrentUser(state)
    };
};
const mapDispatchToProps = (dispatch, props)=>{
    const streamId = getStreamId(props.typeId, props.deviationId);
    return {
        initializeStream () {
            dispatch(withOffset.actions.initialize({
                streamId,
                itemsPerFetch: 24,
                hasMore: true,
                streamParams: {
                    typeId: props.typeId,
                    deviationId: props.deviationId
                },
                fetchNextCallback: fetchNext.toString()
            }));
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps);

//# sourceMappingURL=FavouritedByModal.container.js.map